import type { BulkEmail, CreateBulkEmailPayload } from "@/schema"

import { ApiContext, apiContextFetch } from "@/hooks/api/base"

export interface BulkEmailsResponse {
  bulk_emails: BulkEmail[]
}

export function fetchBulkEmails(context: ApiContext) {
  return apiContextFetch<BulkEmailsResponse>(context, "bulk_emails")
}

export async function fetchBulkEmail(context: ApiContext, id: string) {
  return apiContextFetch<BulkEmail>(context, `bulk_emails/${id}`)
}

export async function createBulkEmail(context: ApiContext, payload: CreateBulkEmailPayload) {
  return apiContextFetch<BulkEmail>(context, "bulk_emails", {
    method: "POST",
    body: JSON.stringify({ bulk_email: payload }),
  })
}

export async function cancelBulkEmail(context: ApiContext, id: string) {
  return apiContextFetch<void>(context, `bulk_emails/${id}`, {
    method: "DELETE",
  })
}

export async function cancelBulkEmailRecipient(context: ApiContext, bulkEmailId: string, recipientId: string) {
  return apiContextFetch<void>(context, `bulk_emails/${bulkEmailId}/bulk_email_recipients/${recipientId}`, {
    method: "DELETE",
  })
}
